import { useSignal } from '@preact/signals-react'
import { useCallback, useEffect } from 'react'
import { postSubmit } from '@ui-seeker/utils'
import { BACKEND_APIS } from '@constants'
import { leadingOpenUrlModal, formData, leadingUrlId } from 'Pages/BusinessLogistics/LeadingAnalyzer/Page/@signals'
import { useToast } from '@hooks'

export default function useLeadingUrlModalSubmit(name) {

	const isLoading = useSignal(false)
	const { showToast } = useToast()

	const setIsLoading = () => isLoading.value = true

	const onSubmit = useCallback(() => {
		postSubmit(`${BACKEND_APIS.DASHBOARD}/save-filters`, { name, path: leadingOpenUrlModal.value, payload: formData.value })
			.then(({ value }) => {
				showToast.success(`Successfully saved link with name: ${name}`)
				leadingOpenUrlModal.value = false
				leadingUrlId.value = value
				isLoading.value = false
			})
			.catch(() => {
				showToast.error(`Failed to save link with name: ${name}`)
				isLoading.value = false
			})
	}, [name])

	useEffect(() => {
		if (isLoading.value) onSubmit()
	}, [isLoading.value])

	return {
		isLoading: isLoading.value,
		setIsLoading,
	}
}